import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";

import Chat from "../application/chat";
import ChatMobile from "../application/ChatMobile";
import LoginMobile from "../application/LoginMobile";
import Connections from "../application/Connections";
import LeadsDashboard from "../mainMenu/leadsDashboard";
import DashboardTnp from "../mainMenu/dashboardTnp";
import DashboardCliente from "../mainMenu/dashboardCliente";
import KanbanView from "../application/kanbanView";
import KanbanViewPipeline from "../application/kanbanViewPipeline";
import LeadsGrid from "../crm/leads/leadsGrid";
import LeadsList from "../crm/leads/leadsList";
import Agenda from "../crm/leads/agendamento";
import PagamentoPage from "../crm/leads/pagamento";
import PipelineList from "../crm/leads/pipelineList";
import Pipeline from "../crm/pipeline/pipeline";
import Todo from "../application/todo/todo"
import TodoAdmin from "../application/todo/todoAdmin";
import CardBuilder from "../application/todo/card-builder";
import CardBuilderAdmin from "../application/todo/card-builder-admin";
import BibliotecaMidias from "../application/biblioteca-midias";
import RespostasRapidas from "../application/respostas-rapidas";
import TeamUserManagement from "../application/todo/TeamUserManagement";
import AdminChats from '../application/AdminChats';
import WhatsAppTemplates from '../application/whatsapp/WhatsAppTemplates';
import TemplatesComErro from '../application/templatesComErro';
import LeadsType from '../application/leadsType';
import Discadora from '../application/discadora';

import MultiConta from '../application/multiconta/MultiConta';
import { multicontaAtivo } from '../../core/session/multiconta';

import Login3 from "../auth/login/login-3";
import AdminLogin from '../auth/login/AdminLogin';
import WhiteLabelAdmin from '../auth/login/WhiteLabelAdmin';
import Register3 from "../auth/register/register-3";
import TwoStepVerification from "../auth/twoStepVerification/twoStepVerification";
import EmailVerification from "../auth/emailVerification/emailVerification";
import ResetPassword from "../auth/resetPassword/resetPassword";
import ForgotPassword from "../auth/forgotPassword/forgotPassword";
import ResetPasswordSuccess from "../auth/resetPasswordSuccess/resetPasswordSuccess";
import LockScreen from "../auth/lockScreen";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import LimparCache from "../pages/LimparCache";


const routes = all_routes;

export const publicRoutes = [
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/entrar" />,
    route: Route,
  },
  {
    path: routes.leadsDashboard,
    element: <LeadsDashboard />,
    route: Route,
  },
  {
    path: routes.dashboardTnp,
    element: <DashboardTnp />,
    route: Route,
  },
  {
    path: routes.dashboardCliente,
    element: <DashboardCliente />,
    route: Route,
  },
  {
    path: routes.chat,
    element: <Chat />,
    route: Route,
  },
  {
    path: routes.mobileApp,
    element: <ChatMobile />,
    route: Route,
  },
  {
    path: routes.mobileAppLogin,
    element: <LoginMobile />,
    route: Route,
  },
  {
    path: routes.bibliotecaMidias,
    element: <BibliotecaMidias />,
    route: Route,
  },
  {
    path: routes.respostasRapidas,
    element: <RespostasRapidas />,
    route: Route,
  },
  {
    path: routes.connections,
    element: <Connections />,
    route: Route,
  },
  {
    path: routes.limparCache,
    element: <LimparCache />,
    route: Route,
  },
  {
    path: routes.adminChats,
    element: <AdminChats />,
    route: Route,
  },
  {
    path: routes.templatesComErro,
    element: <TemplatesComErro />,
    route: Route,
  },
  {
    path: routes.leadsType,
    element: <LeadsType />,
    route: Route,
  },
  {
    path: routes.discadora,
    element: <Discadora />,
    route: Route,
  },
  {
    path: routes.kanbanView,
    element: <KanbanView />,
    route: Route,
  },
  {
    path: routes.leadsGrid,
    element: <LeadsGrid />,
    route: Route,
  },
  {
    path: routes.leadsList,
    element: <LeadsList />,
    route: Route,
  },
  {
    path: routes.todo,
    element: <Todo />,
    route: Route,
  },
  {
    path: routes.todoAdmin,
    element: <TodoAdmin />,
    route: Route,
  },
  {
    path: routes.agendamento,
    element: <Agenda />,
    route: Route,
  },
  {
    path: routes.pagamento,
    element: <PagamentoPage />,
    route: Route,
  },
  {
    path: routes.cardBuilder,
    element: <CardBuilder />,
    route: Route,
  },
  {
    path: routes.cardBuilderAdmin,
    element: <CardBuilderAdmin />,
    route: Route,
  },
  {
    path: routes.teamUserManagement,
    element: <TeamUserManagement />,
    route: Route,
  },
  {
    path: routes.whatsappTemplates,
    element: <WhatsAppTemplates />,
    route: Route,
  }
];

export const authRoutes = [
  {
    path: routes.login3,
    element: <Login3 />,
    route: Route,
  },
  // Shell do multi-conta: ocupa a tela inteira e renderiza cada conta num frame.
  // Fica em authRoutes porque NÃO pode ter o layout do CRM em volta — o layout vem de
  // dentro de cada frame. Com o recurso desligado (interruptor no public/index.html) a
  // rota nem é registrada: /contas cai no 404 como qualquer caminho inexistente.
  ...(multicontaAtivo()
    ? [{
        path: routes.multiConta,
        element: <MultiConta />,
        route: Route,
      }]
    : []),
  {
    path: routes.adminlogin,
    element: <AdminLogin />,
    route: Route,
  },
  {
    path: routes.wladmin,
    element: <WhiteLabelAdmin />,
    route: Route,
  },
  {
    path: routes.register3,
    element: <Register3 />,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <ResetPasswordSuccess />,
    route: Route,
  },
  {
    path: routes.lockScreen,
    element: <LockScreen />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: routes.limparCache,
    element: <LimparCache />,
    route: Route,
  },
];
